import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskOrganizationsRoute: InvariantJiraRoute = {
	name: 'servicedesk-organizations',
	path: '/jira/servicedesk/projects/:projectKey/organizations',
	exact: true,
};
